import { useState, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import { getPresignedUrl, uploadFile } from "../../api";
import CommonModal from "../../containers/common_modal";
import MultiDropDown from "../../containers/multi_select_dropdown";
import "./upload_apk.css";

const UploadApk = ({ locs }) => {
  const [file, setFile] = useState("");
  const [isError, setIsError] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const successOpenRef = useRef();
  const successCloseRef = useRef();
  const fileRef = useRef();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
  } = useForm({
    defaultValues: {
      appId: "",
      version: "",
      notes: "",
      locs: [],
    },
  });

  const onSubmitAPK = async (data) => {
    try {
      setIsError(false);
      if (!file) {
        setIsError(true);
        return;
      }
      setIsUploading(true);
      let payload = {
        app_id: data?.appId,
        version: data?.version,
        release_notes: data?.notes,
        loc: data?.locs.map((loc) => loc?.loc).join(",") || "",
      };
      const presignedUrl = await getPresignedUrl(payload);
      if (presignedUrl?.data?.url) {
        await onUploadApk(presignedUrl);
      }
    } catch (error) {
      setIsUploading(false);
      console.log(error);
    }
  };

  const onUploadApk = async (APIresponse) => {
    try {
      const fileUploadData = new FormData();
      Object.keys(APIresponse.data["fields"]).forEach((key) => {
        fileUploadData.append(key, APIresponse.data["fields"][key]);
      });
      fileUploadData.append("file", file);

      const fileUploaded = await uploadFile(
        APIresponse.data["url"],
        fileUploadData
      );
      if (fileUploaded) {
        successOpenRef.current.click();
        setIsUploading(false);
        resetFields();
      }
      setIsUploading(false);
    } catch (error) {
      setIsUploading(false);
      console.log(error);
    }
  };

  const resetFields = () => {
    reset();
    fileRef.current.value = "";
  };

  const UploadSuccess = () => (
    <div className="d-flex flex-column align-items-center py-4">
      <div className="au-modtext">File Uploaded successfully</div>
      <button
        className="btn btn-success mt-4 d-flex align-items-center"
        onClick={() => {
          successCloseRef.current.click();
        }}
      >
        <div> OK</div>
      </button>
    </div>
  );

  return (
    <>
      <form
        className="d-flex flex-column justify-content-center up-box"
        onSubmit={handleSubmit(onSubmitAPK)}
      >
        <div className="d-flex flex-column mb-4 mt-4">
          <div className="d-flex justify-content-between align-items-center">
            <div className="sf-label">App ID</div>
            <input
              type={"text"}
              className={[
                "form-control upload-form w-50",
                errors.appId?.type === "required" && "border-red",
              ].join(" ")}
              placeholder="Enter App ID"
              {...register("appId", { required: true })}
            />
          </div>
          {errors.appId?.type === "required" && (
            <div className="error-text ms-auto">App ID is required</div>
          )}
        </div>

        <div className="d-flex flex-column mb-4">
          <div className="d-flex justify-content-between align-items-center">
            <div className="sf-label">Loc</div>
            <div className="w-50">
              <Controller
                name="locs"
                control={control}
                rules={{ required: "Value is required." }}
                render={({ field }) => {
                  return (
                    <MultiDropDown
                      options={locs}
                      optionLabel={"loc"}
                      placeholder="Select Locs"
                      onChangeValues={(data) => {
                        field.onChange(data);
                      }}
                      error={errors.loc?.type}
                    />
                  );
                }}
              />
            </div>
          </div>
          {errors.loc?.type === "required" && (
            <div className="error-text ms-auto">Loc is required</div>
          )}
        </div>

        <div className="d-flex flex-column mb-4">
          <div className="d-flex justify-content-between align-items-center">
            <div className="sf-label">Version</div>
            <input
              type={"text"}
              className={[
                "form-control upload-form w-50",
                errors.version?.type === "required" && "border-red",
              ].join(" ")}
              placeholder="Enter Version"
              {...register("version", { required: true })}
            />
          </div>
          {errors.version?.type === "required" && (
            <div className="error-text ms-auto">Version is required</div>
          )}
        </div>

        <div className="d-flex flex-column mb-4">
          <div className="d-flex justify-content-between align-items-center">
            <div className="sf-label">Release Notes</div>
            <textarea
              className={[
                "form-control upload-form w-50",
                errors.notes?.type === "required" && "border-red",
              ].join(" ")}
              placeholder="Enter Release Notes"
              {...register("notes", { required: true })}
            />
          </div>
          {errors.notes?.type === "required" && (
            <div className="error-text ms-auto">Release Notes is required</div>
          )}
        </div>

        <div className="d-flex flex-column">
          <div className="d-flex justify-content-between align-items-center">
            <div className="sf-label">Select File</div>
            <input
              type={"file"}
              className={[
                "form-control w-50",
                isError && !file && "border-red",
              ].join(" ")}
              onChange={(e) => setFile(e.target.files[0])}
              ref={fileRef}
            />
          </div>
          {isError && !file && (
            <div className="error-text ms-auto">
              Please select file to upload
            </div>
          )}
        </div>

        <div className="d-flex justify-content-center">
          <button
            className="btn btn-primary mt-4 d-flex align-items-center"
            type="submit"
            disabled={isUploading}
          >
            <div>{isUploading ? "Uploading..." : "Upload APK"}</div>
            {isUploading && <div className="spinner ms-2"></div>}
          </button>
        </div>
      </form>
      <CommonModal
        modalOpenRef={successOpenRef}
        modalCloseRef={successCloseRef}
        id={"successModal"}
        content={<UploadSuccess />}
        modalSize={"md"}
        onModalClose={() => successCloseRef.current.click()}
      />
    </>
  );
};
export default UploadApk;
